import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { getFactorChart } from '../charts.js';
import './Factors.css';
import i18n from '../../../i18n';

const Factor = (props) => {
  const { data, name } = props;


  const asOfDate = () => {
    const funds = data.filter((x) => x.multifactorTilts !== null);
    if (funds.length > 0) {
      const value = funds[0].multifactorTilts[0];
      return new Date(value.date).toLocaleString().split(',')[0].split(' ')[0];
    } else {
      return null;
    }
  };

  const factorDef = (name) => {
    switch (name) {
      case 'Correlation':
        return i18n.t('comp-correlation');
      case 'Momentum':
        return i18n.t('comp-momentum');
      case 'Quality':
        return i18n.t('comp-quality');
      case 'Value':
        return i18n.t('comp-value');
      default:
        return '';
    }
  };

  return (
    <div className="col-md-6">
      <div className='factors-chart-header'>
        {i18n.t(name).toUpperCase()} {i18n.t('as of')} {asOfDate()}
      </div>
      <div className='factorDef'>{factorDef(name)}</div>
      <div className='chartContainer'>
        <ReactEcharts
          option={getFactorChart(name, data)}
          theme='default'
          style={{ height: 240 }}
        />
      </div>
    </div>
  );
};

export default Factor;
